import React from "react";
import UserManagementPage from "./UserManagementPage";
import UserContextManagementPage from "./UserContextManagementPage";
import Card from "components/ui-elements/Card";

export default function UserAdministrationPage() {
  return (
    <div>
      <Card title="Manajemen User" className="mb-3">
        <UserManagementPage />
      </Card>
      <Card title="Assignment User Context">
        <UserContextManagementPage />
      </Card>
    </div>
  );
}
